var c = /* @__PURE__ */ ((a) => (a.Machine = "machine", a.Accessory = "accessory", a.Capsule = "capsule", a.Giftcard = "giftcard", a.Servicepackage = "servicepackage", a))(c || {}), r = /* @__PURE__ */ ((a) => (a.IMAGE = "IMAGE", a.VIDEO = "VIDEO", a.OTHER = "OTHER", a))(r || {});
export {
  r as M,
  c as P
};
